import { render, staticRenderFns } from "./UserStatsContent.vue?vue&type=template&id=f48f06da"
import script from "./UserStatsContent.vue?vue&type=script&lang=js"
export * from "./UserStatsContent.vue?vue&type=script&lang=js"
import style0 from "./UserStatsContent.vue?vue&type=style&index=0&id=f48f06da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports